module.exports = __webpack_public_path__ + "img/roadside-assist.f49ae43d.png";